export default __webpack_public_path__ + "static/HP-howitworks3-13a473d56b38cbaf1c8799dbce940a98.webp";